import { render, staticRenderFns } from "./SysPositionModal.vue?vue&type=template&id=3aaf2fb2&scoped=true&"
import script from "./SysPositionModal.vue?vue&type=script&lang=js&"
export * from "./SysPositionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aaf2fb2",
  null
  
)

export default component.exports